import React from 'react';

const PrefabEditor = () => <div>PrefabEditor inspector</div>;

export default PrefabEditor;



// WEBPACK FOOTER //
// ./src/components/Inspector/prefabEditor.js